module.exports = {
  BASE_URL_NEW: 'https://indiasmartgrid.org/isgf/api/',
  BASE_URL: "https://indiasmartgrid.org/isgf/api/",
  assetUrl: 'https://indiasmartgrid.org/isgf',
};